<div class="minor-page-wrapper" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="10px"
    fxLayoutGap.lt-md="40px" fxFlex>
    <!-- Account Summary/Prices Row -->
    <div fxLayout.lt-lg="column" fxLayoutAlign="center stretch" fxLayoutGap="10px" fxLayoutGap.lt-lg="20px" fxFlex
        fxFlex.lt-lg="440px">
        <!-- Account summary -->
        <div class="panel" style="background-color: white;" fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
            <div class="summary-panel-header" fxLayoutAlign="start center" fxFlex="45px">Account Summary</div>
            <div class="summary-panel-body" fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
                <div fxFlex>                  
                    <div style="background-color: white;" fxLayout="column" fxLayoutAlign="center stretch" fxFlex="50%">
                        <div class="summary-item-label" fxLayoutAlign="start center" fxFlex>Credit/(Loan) Balance:</div>
                        <div class="summary-item-label" fxLayoutAlign="start center" fxFlex>Commodity Lease Proceeds:</div>
                        <div class="summary-item-label" fxLayoutAlign="start center" fxFlex>Commodity Lease MV:</div>
                        <div class="summary-item-label" fxLayoutAlign="start center" fxFlex>Total Credit/(Indebtedness):</div>
                        <div class="summary-item-label" fxLayoutAlign="start center" fxFlex>MV Owned:</div>
                        <div class="summary-item-label" fxLayoutAlign="start center" fxFlex>Net Account Value:</div>
                        <div class="summary-item-label" fxLayoutAlign="start center" fxFlex>Collateral Ratio - Equity:</div>
                    </div>
                    <div style="background-color: rgb(238, 150, 150);" fxLayout="column" fxLayoutAlign="center stretch"
                        fxFlex>
                        <div style="background-color: white;" fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                            <div fxLayoutAlign="end center" fxFlex>{{ loanBalance | number : '1.2-2' | minusSignToParens }}</div>
                            <div fxLayoutAlign="end center" fxFlex>{{ leaseProceedsBalance | number : '1.2-2' | minusSignToParens }}</div>
                            <div fxLayoutAlign="end center" fxFlex>{{leaseMVBalance | number : '1.2-2' | minusSignToParens }}</div>
                            <div fxLayoutAlign="end center" fxFlex></div>
                            <div fxLayoutAlign="end center" fxFlex></div>
                            <div fxLayoutAlign="end center" fxFlex></div>
                            <div fxLayoutAlign="end center" fxFlex></div>
                        </div>
                    </div>
                    <div style="background-color: rgb(59, 9, 9);" fxLayout="column" fxLayoutAlign="center stretch"
                        fxFlex>
                        <div style="background-color: white;" fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                            <div fxLayoutAlign="end center" fxFlex></div>
                            <div fxLayoutAlign="end center" fxFlex></div>
                            <div fxLayoutAlign="end center" fxFlex></div>
                            <div fxLayoutAlign="end center" fxFlex>{{totalIndebtedness | number : '1.2-2' | minusSignToParens }}</div>
                            <div fxLayoutAlign="end center" fxFlex>{{longMVBalance | number : '1.2-2' | minusSignToParens }}</div>
                            <div fxLayoutAlign="end center" fxFlex>{{netAccountValue | number : '1.2-2' | minusSignToParens }}</div>
                            <div fxLayoutAlign="end center" fxFlex>{{equityPct | number : '1.2-2' | minusSignToParens }}%</div>
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
        <!-- Prices -->
        <div class="panel" style="background-color: white;" fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
            <div class="summary-panel-header" fxLayoutAlign="start center" fxFlex="45px">Monex Spot Prices</div>
            <div fxFlex>
                <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                    <div fxLayoutAlign="end center" fxFlex>Spot</div>
                    <div fxLayoutAlign="end center" fxFlex>Last:</div>
                    <div fxLayoutAlign="end center" fxFlex>Change:</div>
                    <div fxLayoutAlign="end center" fxFlex>% Change:</div>
                    <div fxLayoutAlign="end center" fxFlex>Open:</div>
                    <div fxLayoutAlign="end center" fxFlex>High:</div>
                    <div fxLayoutAlign="end center" fxFlex>Low:</div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center stretch"
                    fxFlex>
                    <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayoutAlign="center center" fxFlex>Gold</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ goldSpotPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center"
                            [ngStyle]="goldPriceChange < 0?{'color':'red'} : {'color': 'green'}" fxFlex>
                            {{ goldPriceChange | number : '1.2-2' }}
                        </div>
                        <div fxLayoutAlign="center center"
                            [ngStyle]="goldPriceChange < 0?{'color':'red'} : {'color': 'green'}" fxFlex>
                            {{ goldPctPriceChange | number : '1.2-2' }}%
                        </div>
                        <div fxLayoutAlign="center center" fxFlex>{{ goldOpenPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ goldHighPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ goldLowPrice | number : '1.2-2' }}</div>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center stretch"
                    fxFlex>
                    <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayoutAlign="center center" fxFlex>Silver</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ silverSpotPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center"
                            [ngStyle]="silverPriceChange < 0?{'color':'red'} : {'color': 'green'}" fxFlex>
                            {{ silverPriceChange | number : '1.2-2' }}
                        </div>
                        <div fxLayoutAlign="center center"
                            [ngStyle]="silverPriceChange < 0?{'color':'red'} : {'color': 'green'}" fxFlex>
                            {{ silverPctPriceChange | number : '1.2-2' }}%
                        </div>
                        <div fxLayoutAlign="center center" fxFlex>{{ silverOpenPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ silverHighPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ silverLowPrice | number : '1.2-2' }}</div>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center stretch"
                    fxFlex>
                    <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayoutAlign="center center" fxFlex>Platinum</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ platinumSpotPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center"
                            [ngStyle]="platinumPriceChange < 0?{'color':'red'} : {'color': 'green'}" fxFlex>
                            {{ platinumPriceChange | number : '1.2-2' }}
                        </div>
                        <div fxLayoutAlign="center center"
                            [ngStyle]="platinumPriceChange < 0?{'color':'red'} : {'color': 'green'}" fxFlex>
                            {{ platinumPctPriceChange | number : '1.2-2' }}%
                        </div>
                        <div fxLayoutAlign="center center" fxFlex>{{ platinumOpenPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ platinumHighPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ platinumLowPrice | number : '1.2-2' }}</div>
                    </div>
                </div>
                <div fxLayout="column" fxLayoutAlign="center stretch"
                    fxFlex>
                    <div fxLayout="column" fxLayoutAlign="center stretch" fxFlex>
                        <div fxLayoutAlign="center center" fxFlex>Palladium</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ palladiumSpotPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center"
                            [ngStyle]="palladiumPriceChange < 0?{'color':'red'} : {'color': 'green'}" fxFlex>
                            {{ palladiumPriceChange | number : '1.2-2' }}
                        </div>
                        <div fxLayoutAlign="center center"
                            [ngStyle]="palladiumPriceChange < 0?{'color':'red'} : {'color': 'green'}" fxFlex>
                            {{ palladiumPctPriceChange | number : '1.2-2' }}%
                        </div>
                        <div fxLayoutAlign="center center" fxFlex>{{ palladiumOpenPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ palladiumHighPrice | number : '1.2-2' }}</div>
                        <div fxLayoutAlign="center center" fxFlex>{{ palladiumLowPrice | number : '1.2-2' }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Chart Row -->
    <div class="panel chart-panel" fxLayout="column" fxLayoutAlign="start stretch" fxFlex>
        <div class="summary-panel-header" fxLayoutAlign="start center" fxFlex="45px">Monex Spot Price Charts</div>
        <div fxLayoutAlign="center stretch" fxFlex>
            <mat-tab-group style="background-color: transparent;" mat-align-tabs="end"
                (selectedTabChange)="onTabChanged($event);" fxFlex>
                <mat-tab label="Gold" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                    <ng-template matTabContent>
                        <div fxFlex>
                            <apx-chart #goldApexChart [chart]="goldApexChart" [chart]="goldApexChart"
                                [series]="goldChartOptions.series" [chart]="goldChartOptions.chart"
                                [colors]="goldChartOptions.colors" [yaxis]="goldChartOptions.yaxis"
                                [dataLabels]="goldChartOptions.dataLabels" [markers]="goldChartOptions.markers"
                                [stroke]="goldChartOptions.stroke" [xaxis]="goldChartOptions.xaxis"
                                [tooltip]="goldChartOptions.tooltip" [annotations]="goldChartOptions.annotations">
                            </apx-chart>
                        </div>
                    </ng-template>
                </mat-tab>
                <mat-tab label="Silver" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                    <ng-template matTabContent>
                        <div fxFlex>
                            <apx-chart #silverApexChart [chart]="silverApexChart" [series]="silverChartOptions.series"
                                [chart]="silverChartOptions.chart" [colors]="silverChartOptions.colors"
                                [yaxis]="silverChartOptions.yaxis" [dataLabels]="silverChartOptions.dataLabels"
                                [markers]="silverChartOptions.markers" [stroke]="silverChartOptions.stroke"
                                [xaxis]="silverChartOptions.xaxis" [tooltip]="silverChartOptions.tooltip"
                                [annotations]="silverChartOptions.annotations">
                            </apx-chart>
                        </div>
                    </ng-template>
                </mat-tab>
                <mat-tab label="Platinum" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                    <ng-template matTabContent>
                        <div fxFlex>
                            <apx-chart #platinumApexChart [chart]="platinumApexChart"
                                [series]="platinumChartOptions.series" [chart]="platinumChartOptions.chart"
                                [colors]="platinumChartOptions.colors" [yaxis]="platinumChartOptions.yaxis"
                                [dataLabels]="platinumChartOptions.dataLabels" [markers]="platinumChartOptions.markers"
                                [stroke]="platinumChartOptions.stroke" [xaxis]="platinumChartOptions.xaxis"
                                [tooltip]="platinumChartOptions.tooltip"
                                [annotations]="platinumChartOptions.annotations">
                            </apx-chart>
                        </div>
                    </ng-template>
                </mat-tab>
                <mat-tab label="Palladium" fxLayout="column" fxLayoutAlign="center center" fxFlex>
                    <ng-template matTabContent>
                        <div fxFlex>
                            <apx-chart #palladiumApexChart [chart]="palladiumApexChart"
                                [series]="palladiumChartOptions.series" [chart]="palladiumChartOptions.chart"
                                [colors]="palladiumChartOptions.colors" [yaxis]="palladiumChartOptions.yaxis"
                                [dataLabels]="palladiumChartOptions.dataLabels"
                                [markers]="palladiumChartOptions.markers" [stroke]="palladiumChartOptions.stroke"
                                [xaxis]="palladiumChartOptions.xaxis" [tooltip]="palladiumChartOptions.tooltip"
                                [annotations]="palladiumChartOptions.annotations">
                            </apx-chart>
                        </div>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
    <div class="footer-panel" fxLayout="column" fxFlex.lt-lg="350px" fxFlex="260px">
        <div fxFlex="50px">
            <h1>Things you need to know and remember:</h1>
        </div>
        <p>
            For assistance with this summary, please refer to the guide located on the back of your Monex Monthly
            Account Statement, which was recently mailed to your address on record.
        </p>
        <p>
            We encourage you to monitor your account regularly and maintain open communication with your Account
            Representative. If any part of this online summary or a specific transaction does not meet your
            expectations, please contact your Representative’s Supervisor immediately. Furthermore, any suspected
            inaccuracies or unauthorized activity must be reported to the Monex Compliance Department without
            delay; failure to report these issues promptly may affect your right to contest them later.
        </p>
    </div>
</div>